"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _FadeOut = _interopRequireDefault(require("../style/FadeOut.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// If you change DURATION, change the transition time in FadeOut.scss
var DURATION = 2000;
var timeout = {
  appear: 0,
  enter: 0,
  exit: DURATION
};
/**
 * FadeOut component
 * This component is used to handle fading out content.
 *
 * It will perform the fade out either 0 or 1 times.
 *   - If isVisible=true on mount, a fade out will never happen.
 *   - If isVisible=false on mount, a fade out will happen once.
 * After the initial fadeout is complete, the component will toggle
 * visibility with the isVisible prop without a fadeout.
 *
 * The fade cycle is as follows:
 *   1. Start hidden, (constructor: in=false)
 *   2. Immediately show, (componentDidMount: in=true)
 *   3. After the component shows, begin fade out: (onEnter: in=false)
 *
 * We must start with in=false so that onEnter will trigger.
 * This is a quirk of CSSTransition.
 *
 * * @reactProps {boolean} isVisible - indication if the component should be shown. This will cancel the fadeout
 * * @reactProps {Element} children - Element to be faded out.
 */

var FadeOut = /*#__PURE__*/function (_Component) {
  _inherits(FadeOut, _Component);

  var _super = _createSuper(FadeOut);

  /**
   * FadeOut Constructor
   * @param {Object} props - props for FadeOut
   */
  function FadeOut(props) {
    var _this;

    _classCallCheck(this, FadeOut);

    _this = _super.call(this, props);
    _this.state = {
      // skip fadeout if isVisible
      isComplete: _this.props.isVisible,
      in: false
    };
    _this.onEntered = _this.onEntered.bind(_assertThisInitialized(_this));
    _this.onExit = _this.onExit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FadeOut, [{
    key: "componentDidMount",

    /**
     * Lifecyle function for after mount.
     * @returns {undefined}
     */
    value: function componentDidMount() {
      this.setState(function () {
        return {
          in: true
        };
      });
    }
    /**
     * Lifecyle function for unmounting.
     * @returns {undefined}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.exitTimeout);
    }
    /**
     * Begin fade out by setting in=false
     * @return {undefined}
     */

  }, {
    key: "onEntered",
    value: function onEntered() {
      this.setState(function () {
        return {
          in: false
        };
      });
    }
    /**
     * Fade out is complete, set isComplete to disallow future fade outs.
     * @return {undefined}
     */

  }, {
    key: "onExit",
    value: function onExit() {
      var _this2 = this;

      this.exitTimeout = setTimeout(function () {
        return _this2.setState(function () {
          return {
            isComplete: true
          };
        });
      }, DURATION);
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var isVisible = this.props.isVisible;
      var isComplete = this.state.isComplete;
      return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        classNames: "fade",
        in: isVisible || this.state.in,
        timeout: timeout,
        onEntered: this.onEntered,
        onExit: this.onExit,
        unmountOnExit: !isVisible
      }, function () {
        return !isVisible && isComplete ? null : /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(_FadeOut.default.component, " ").concat(isVisible ? 'is-visible' : 'not-visible', " ").concat(isComplete ? 'is-complete' : '')
        }, _this3.props.children);
      });
    }
  }]);

  return FadeOut;
}(_react.Component);

_defineProperty(FadeOut, "propTypes", {
  children: _propTypes.default.node,
  isVisible: _propTypes.default.bool
});

var _default = FadeOut;
exports.default = _default;